export default __webpack_public_path__ + "static/media/llave_mano.e72607f5.png";